import ValidService from "../../service/ValidService";

let model = {};

model.tableRules = {
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 20,
    offset: 0,
    sort: "name",
    defaultSort: ["name", "ascending"],
    fields: "id,service_id,name,type,weight,description,is_lock",
    filters: "",
    dataSearch: {
        value: {
            name: "",
            type: "",
            weight: null,
        },
        valid: {
            name: [ValidService.checkNameAllowVN],
            type: [],
        },
        operator: {
            name: ":regex_i:",
            type: "",
             weight: "",
        },
    },
};

export default model;
